import { Radar } from "react-chartjs-2"
import {
Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'
import { Diagnosis } from "../types/Diagnosis";
import { useCallback } from "react";

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const MetricsChart = ({diagnosis}:Props) => {

    const renderTotal = useCallback((i:Diagnosis)=>{
        if(!i.total || !i.score) return 0
        let total = (((100*i.score)/i.total)/10)*1
        if(total > 10) return 10
        else return total
    },[])

    return (
        <div className="">
            <Radar
                options={{
                    scales: {
                        r: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 2,
                            },
                            suggestedMax: 10,   
                        }
                        
                    },
                    
                }}
                data={ {
                    labels: diagnosis.map( i => i.name),
                    datasets: [
                        {
                            label: 'Metricas',
                            data: diagnosis.map( i => renderTotal(i)),
                            backgroundColor: '#FACA0080',
                            borderColor: '#8C730A66',
                            borderWidth: 1
                        },
                        {   
                            label:"",
                            data: diagnosis.map(i => i ?  10 : 0),
                            backgroundColor: '#E0E0E066',
                            pointBorderWidth:0,
                            borderWidth:0

                        }
                    ]
                }}
                
            />
        </div>
    )
}

interface Props {
    diagnosis: Diagnosis[]
}
export default MetricsChart
